<template>
    <div>
      <b-nav tabs>
        <b-nav-item :class="{active: $route.name==='Clases en directo'}" :to="{ name: 'Clases en directo' }">{{ $t("header.sessions") }}</b-nav-item>
        <b-nav-item :class="{active: $route.name==='Grabaciones'}" :to="{ name: 'Grabaciones' }">{{ $t("header.recordings") }}</b-nav-item>
      </b-nav>
    </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: ['collapsed'],
  data () {
    return {
      menu: [
        {
          header: true,
          title: this.$i18n.t('menu.principal'),
          hiddenOnCollapse: true
        },
        {
          href: '/sesiones',
          title: this.$i18n.t('header.sessions'),
          icon: 'fa fa-video-camera'
        },
        {
          href: '/grabaciones',
          title: this.$i18n.t('menu.recordedsessions'),
          icon: 'fa fa-film'
        }
      ]
    }
  },
  methods: {
    onToggleCollapse (collapsed) {
      console.log(collapsed)
      this.$emit('toggleCollapse', collapsed)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/Sidebar.vue